import { FEATURE_FLAGS } from '../../../../featureFlags';
import { frontendURL } from '../../../../helper/URLHelper';

// eslint-disable-next-line global-require
const icon = name => require(`dashboard/assets/images/sidebar/${name}.svg`);

const settings = accountId => ({
  parentNav: 'settings',
  routes: [
    'agent_bots',
    'agent_list',
    'roles_list',
    'attributes_list',
    'automation_list',
    'auditlogs_list',
    // 'billing_settings_index',
    'canned_list',
    'general_settings_index',
    'general_settings',
    'labels_list',
    'queues_list',
    'macros_edit',
    'macros_new',
    'macros_wrapper',
    'settings_applications_integration',
    'settings_applications_webhook',
    'settings_applications',
    'settings_inbox_finish',
    'settings_inbox_list',
    'settings_inbox_new',
    'settings_inbox_show',
    'settings_inbox',
    'settings_inboxes_add_agents',
    'settings_inboxes_page_channel',
    // 'settings_integrations_dashboard_apps',
    // 'settings_integrations_integration',
    // 'settings_integrations_slack',
    // 'settings_integrations_webhook',
    // 'settings_integrations',
    'settings_teams_add_agents',
    'settings_teams_edit_finish',
    'settings_teams_edit_members',
    'settings_teams_edit',
    'settings_teams_finish',
    'settings_teams_list',
    'settings_teams_new',
    'sla_list',
    'knowledge_base_index',
    'knowledge_base_wrapper',
    'csat_survey_list',
  ],
  menuItems: [
    {
      icon: 'briefcase',
      label: 'ACCOUNT_SETTINGS',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/settings/general`),
      toStateName: 'general_settings_index',
      iconSrc: icon('work'),
    },
    {
      icon: 'people',
      label: 'AGENTS',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/settings/agents/list`),
      toStateName: 'agent_list',
      iconSrc: icon('user'),
      featureFlag: FEATURE_FLAGS.AGENT_MANAGEMENT,
    },
    {
      icon: 'lock-shield',
      label: 'ROLES',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/settings/roles/list`),
      toStateName: 'roles_list',
      iconSrc: icon('lock'),
    },
    {
      icon: 'people-team',
      label: 'TEAMS',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/settings/teams/list`),
      toStateName: 'settings_teams_list',
      iconSrc: icon('user-group'),
      featureFlag: FEATURE_FLAGS.TEAM_MANAGEMENT,
    },
    {
      icon: 'document-list-clock',
      label: 'QUEUES',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/settings/queues/list`),
      toStateName: 'queues_list',
      featureFlag: FEATURE_FLAGS.QUEUE_MANAGEMENT,
    },
    {
      icon: 'mail-inbox-all',
      label: 'INBOXES',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/settings/inboxes/list`),
      toStateName: 'settings_inbox_list',
      iconSrc: icon('inbox'),
      featureFlag: FEATURE_FLAGS.INBOX_MANAGEMENT,
    },
    {
      icon: 'tag',
      label: 'LABELS',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/settings/labels/list`),
      toStateName: 'labels_list',
      iconSrc: icon('tag'),
      featureFlag: FEATURE_FLAGS.LABELS,
    },
    {
      icon: 'code',
      label: 'CUSTOM_ATTRIBUTES',
      hasSubMenu: false,
      toState: frontendURL(
        `accounts/${accountId}/settings/custom-attributes/list`
      ),
      toStateName: 'attributes_list',
      iconSrc: icon('controller'),
      featureFlag: FEATURE_FLAGS.CUSTOM_ATTRIBUTES,
    },
    {
      icon: 'automation',
      label: 'AUTOMATION',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/settings/automation/list`),
      toStateName: 'automation_list',
      iconSrc: icon('rotate-auto'),
      featureFlag: FEATURE_FLAGS.AUTOMATIONS,
    },
    {
      icon: 'bot',
      label: 'AGENT_BOTS',
      hasSubMenu: false,
      globalConfigFlag: 'csmlEditorHost',
      toState: frontendURL(`accounts/${accountId}/settings/agent-bots`),
      toStateName: 'agent_bots',
      featureFlag: FEATURE_FLAGS.AGENT_BOTS,
    },
    {
      icon: 'flash-settings',
      label: 'MACROS',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/settings/macros`),
      toStateName: 'macros_wrapper',
      iconSrc: icon('lightning-bolt'),
      featureFlag: FEATURE_FLAGS.MACROS,
    },
    {
      icon: 'chat-multiple',
      label: 'CANNED_RESPONSES',
      hasSubMenu: false,
      toState: frontendURL(
        `accounts/${accountId}/settings/canned-response/list`
      ),
      toStateName: 'canned_list',
      iconSrc: icon('messages'),
      featureFlag: FEATURE_FLAGS.CANNED_RESPONSES,
    },
    // {
    //   icon: 'flash-on',
    //   label: 'INTEGRATIONS',
    //   hasSubMenu: false,
    //   toState: frontendURL(`accounts/${accountId}/settings/integrations`),
    //   toStateName: 'settings_integrations',
    //   featureFlag: FEATURE_FLAGS.INTEGRATIONS,
    // },
    {
      icon: 'star-emphasis',
      label: 'APPLICATIONS',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/settings/applications`),
      toStateName: 'settings_applications',
      featureFlag: FEATURE_FLAGS.INTEGRATIONS,
    },
    // {
    //   icon: 'credit-card-person',
    //   label: 'BILLING',
    //   hasSubMenu: false,
    //   toState: frontendURL(`accounts/${accountId}/settings/billing`),
    //   toStateName: 'billing_settings_index',
    //   showOnlyOnCloud: true,
    // },
    {
      icon: 'key',
      label: 'AUDIT_LOGS',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/settings/audit-log/list`),
      toStateName: 'auditlogs_list',
      iconSrc: icon('key'),
      featureFlag: FEATURE_FLAGS.AUDIT_LOGS,
      // beta: true,
    },
    {
      // AI F §1.1.5 — knowledge base sources
      icon: 'book',
      label: 'KNOWLEDGE_BASE',
      hasSubMenu: false,
      toState: frontendURL(
        `accounts/${accountId}/settings/knowledge-base/list`
      ),
      toStateName: 'knowledge_base_index',
      featureFlag: FEATURE_FLAGS.KNOWLEDGE_BASE,
    },
    {
      icon: 'document-list-clock',
      label: 'SLA',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/settings/sla/list`),
      toStateName: 'sla_list',
      iconSrc: icon('clock'),
      isEnterpriseOnly: true,
      featureFlag: FEATURE_FLAGS.SLA,
      // beta: true,
    },
    {
      icon: 'emoji',
      label: 'CSAT_SURVEY',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/settings/csat-survey`),
      toStateName: 'csat_survey_list',
      iconSrc: icon('smiley'),
      isEnterpriseOnly: true,
      featureFlag: FEATURE_FLAGS.CSAT_SURVEY,
      // beta: true,
    },
  ],
});

export default settings;
